import api from './api';
import types from './mutation-types';

export default {
	async getCommCodes_({ commit }, { key, codeType }) {
		try {
			const { header, body } = await api.getCommCodes(codeType);
			if (header.code === 0) {
				const list = [];
				body.length && body.forEach(row => list.push({ label: row.commCdName, value: row.commCd }));
				await commit(types.DEFAULT_ASSIGN, { key, value: list });
			} else if (header.code === 3) {
			}
			return header;
		} catch (error) {
			return error.header || error;
		}
	},
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setSearchInit_({ commit }) {
		commit(types.SEARCH_INIT);
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setStateClear_({ commit }) {
		commit(types.STATE_CLEAR);
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.GROUPS, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	getPartCost_({ commit, state }) {
		const { searchParams, groups } = state;
		return api
			.getPartCost({ searchParams: searchParams, currentPage: groups.currentPage, pageUnit: groups.pageUnit })
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'gridList',
						value: data !== null && data !== undefined ? data.body.resultList : null
					});
					commit(types.DEFAULT_ASSIGN, {
						key: 'groups',
						value: data.body.pagingInfo
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setPartCost_({ commit }, param) {
		return api
			.postPartCost(param)
			.then(data => {
				if (data.header.code === 0) {
					commit(types.DEFAULT_ASSIGN, {
						key: 'gridList',
						value: data !== null && data !== undefined ? data.body[0] : null
					});
				}
				if (data.header.code === 1) {
				}
				if (data.header.code === 2) {
				}
				if (data.header.code === 3) {
				}
				if (data.header.code === 4) {
				}
				if (data.header.code === 5) {
				}

				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	setMasterInfo_({ commit }, { key, value }) {
		commit(types.MASTER_INFO, {
			key: key,
			value: value !== null && value !== undefined ? value : null
		});
	},
	// 저장
	async savePartCost_(store, { saveParams }) {
		return api
			.postPartCost({ saveParams })
			.then(data => {
				if (data.header.code === 0) {
					return data;
				} else {
					throw new Error(data.header.message);
				}
			})
			.catch(error => {
				//throw error;
				throw new Error(error.header.message);
			});
	},
	async excelTempDown_(store, params) {
		try {
			const response = await api.excelTempDown(params);
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			const filename = decodeURIComponent(response.headers.filename);
			link.setAttribute('download', filename);
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			//return error?.header;
			throw new Error(error?.header);
		}
		// try {
		// 	const response = await api
		// 		.excelTempDown(params)
		// 		.then(response => {
		// 			console.log('response', response);
		// 			const url = window.URL.createObjectURL(new Blob([response.data]));
		// 			const link = document.createElement('a');
		// 			link.href = url;
		// 			const filename = decodeURIComponent(response.headers.filename);
		// 			link.setAttribute('download', filename);
		// 			//console.log('filename', filename);
		// 			document.body.appendChild(link);
		// 			link.click();
		// 		})
		// 		.catch(error => {
		// 			throw error;
		// 		});
		// } catch (error) {
		// 	return error?.header;
		// }
	}
};
